// extracted by mini-css-extract-plugin
module.exports = {"section":"_1WaLoCT6BsueWXr3jMAO94","header":"_2sUTw6oZaudp0_7q3PjxZ3"};